// const ScrollReveal = require('scrollreveal');
// ScrollReveal().reveal('.js--fixed-sidebar');

const sidebarJs = function ($) {

    //if ( !$('.js--fixed-sidebar').length ) return;

    $('.js--sidebar-phone-icon').on('touchstart tap', function(e){
        e.preventDefault();
        $('.js--sidebar-phone-number').toggleClass('is--active');
    });

    var sticky = function (el, limit, scrolltop, scrollDirection) {

        //if (scrolltop > limit) el.addClass('sticked');
        //if (scrolltop > limit + 30 && stickIn) el.addClass('in');
        //if (scrolltop == 0) el.removeClass('sticked').removeClass('in');
        // console.log('scrollDirection', scrollDirection);
        // console.log('scrolltop', scrolltop);
        // console.log('limit', limit);

        if (scrolltop < limit || scrollDirection == 'down') {
            el.addClass('in');
        } else {
            el.removeClass('in');
        }
    }

    var _limit = 100,
        _scrollTop = $(window).scrollTop();

    sticky($('.js--fixed-sidebar'), _limit, _scrollTop);

    var lastScrollTop = 0;
    var scrollDirection = '';

    $(window).on('scroll', function () {
        _scrollTop = $(window).scrollTop();

        if (_scrollTop < lastScrollTop) {
            scrollDirection = 'down';
            //console.log('scrollDown');
        } else {
            scrollDirection = 'up';
            //console.log('scrollUp');
        }

        sticky($('.js--fixed-sidebar'), _limit, _scrollTop, scrollDirection);
        lastScrollTop = _scrollTop;
    });

}

export default sidebarJs;
